export default "__VITE_ASSET__176145e9__"